import { render } from "./ModificaMassivaDati.vue?vue&type=template&id=35c9407a&scoped=true"
import script from "./ModificaMassivaDati.vue?vue&type=script&lang=js"
export * from "./ModificaMassivaDati.vue?vue&type=script&lang=js"

import "./ModificaMassivaDati.vue?vue&type=style&index=0&id=35c9407a&scoped=true&lang=css"
import "./ModificaMassivaDati.vue?vue&type=style&index=1&id=35c9407a&lang=css"

import exportComponent from "/Users/andreacotugno/Documents/AGF-Workspace/ask_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35c9407a"]])

export default __exports__